import { makeStyles } from 'e100-react-components';

export const useStyles = makeStyles(({ zIndex }) => ({
  container: {
    display: 'inline-block'
  }
}));